import AvatarRing from "./AvatarRing";
import SubtitleBadge from "./SubtitleBadge";
import Logo from "./Logo";
import { getEquippedItem } from "../cosmetics";
import { ordinal } from "../ordinal";
import { GRADIENT_BG, TEXT_MUTED, TEXT_DARK, TRUST_COLOR } from "../theme";

// Static card captured as an image for sharing a player's monthly rank.
// Designed to match the visual language of ShareableResultCard.
function ShareableRankCard({ userProfile, shopItems = [], rank, points, games, monthLabel }) {
  const borderItem   = getEquippedItem(userProfile, shopItems, "border");
  const subtitleItem = getEquippedItem(userProfile, shopItems, "subtitle");

  return (
    <div style={{ background: GRADIENT_BG, borderRadius: "16px", padding: "28px 22px", textAlign: "center", width: "100%", maxWidth: "380px" }}>
      <div style={{ marginBottom: "20px", display: "flex", justifyContent: "center" }}>
        <Logo size={20} />
      </div>

      {/* Avatar + name + subtitle */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px", marginBottom: "20px" }}>
        <AvatarRing photoURL={userProfile.photoURL} size={80} item={borderItem} fallbackBorder="3px solid #d8dae3" />
        <div style={{ fontWeight: "700", fontSize: "0.9375rem", color: TEXT_DARK }}>{userProfile.displayName}</div>
        {subtitleItem && (
          <div style={{ marginTop: "-4px" }}>
            <SubtitleBadge item={subtitleItem} />
          </div>
        )}
      </div>

      {/* Rank */}
      <div style={{ fontSize: "3rem", fontWeight: "800", color: TRUST_COLOR, lineHeight: 1 }}>
        {ordinal(rank)}
      </div>
      <div style={{ fontSize: "0.8125rem", color: TEXT_MUTED, fontWeight: "600", marginTop: "6px", marginBottom: "18px" }}>
        {monthLabel ? `${monthLabel} leaderboard` : "this month's leaderboard"}
      </div>

      {/* Stats */}
      <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
        <div style={{ flex: 1, padding: "14px", borderRadius: "10px", background: "rgba(255,255,255,0.6)" }}>
          <div style={{ fontSize: "0.6875rem", color: TEXT_MUTED, marginBottom: "4px" }}>points</div>
          <div style={{ fontSize: "1.625rem", fontWeight: "700", color: TEXT_DARK }}>{points}</div>
        </div>
        <div style={{ flex: 1, padding: "14px", borderRadius: "10px", background: "rgba(255,255,255,0.6)" }}>
          <div style={{ fontSize: "0.6875rem", color: TEXT_MUTED, marginBottom: "4px" }}>games</div>
          <div style={{ fontSize: "1.625rem", fontWeight: "700", color: TEXT_DARK }}>{games}</div>
        </div>
      </div>

      <div style={{ fontSize: "0.75rem", color: TEXT_MUTED, fontWeight: "600" }}>play at trustgame.co.uk</div>
    </div>
  );
}

export default ShareableRankCard;
